<template>
  <div v-loading="isLoading">
    <h2>Exceptions</h2>
    <div
      v-for="(skip, index) in schedule.skips"
      :key="index"
    >
      <div style="display: flex;">
        <el-date-picker
          :value="formatAsDaterangeObject(skip.date_from, skip.date_to)"
          type="daterange"
          start-placeholder="Active From"
          end-placeholder="Active To"
          value-format="yyyy-MM-dd"
          class="w-100"
          size="small"
          readonly
        />
        <el-button
          size="mini"
          type="danger"
          style="width: 75px; margin-left: 20px;"
          @click.native="schedule.skips.splice(index, 1)"
        >
          Remove
        </el-button>
      </div>
      <br>
    </div>
    <hr style="margin-top: 5px;">
    <div style="display: flex;">
      <el-date-picker
        v-model="newDateRange"
        type="daterange"
        start-placeholder="Active From"
        end-placeholder="Active To"
        format="dd/MM/yyyy"
        value-format="yyyy-MM-dd"
        class="w-100"
        size="small"
      />
      <el-button
        size="mini"
        style="width: 75px; margin-left: 20px;"
        @click.native="addException"
      >
        Add
      </el-button>
    </div>
    <br>
    <div class="text-right">
      <el-button
        type="primary"
        size="small"
        @click.native="saveSchedule"
      >
        Save Exceptions
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    scheduleId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      schedule: {},
      isLoading: false,
      newDateRange: null
    }
  },
  created () {
    this.loadSchedule()
  },
  methods: {
    loadSchedule () {
      this.isLoading = true
      this.$sdk.scheduledpickup.read(this.scheduleId, builder => {
        builder.include = ['skips']
      }).then(res => { this.schedule = res })
        .finally(() => { this.isLoading = false })
    },
    formatAsDaterangeObject (dateFrom, dateTo) {
      return [dateFrom, dateTo]
    },
    addException () {
      if (this.newDateRange !== null && Array.isArray(this.newDateRange)) {
        let newSkip = new this.$sdk.scheduledpickup_skip()
        newSkip.date_from = this.newDateRange[0]
        newSkip.date_to = this.newDateRange[1]
        this.schedule.skips.push(newSkip)
        this.newDateRange = null
      }
    },
    saveSchedule () {
      this.isLoading = true
      this.schedule.update(builder => {
        builder.include = ['skips']
      })
        .then(() => { this.$message({ message: 'Successfully saved', type: 'success' }) })
        .finally(() => { this.isLoading = false })
    }
  }
}
</script>

<style>

</style>
